import { render } from "./Languages.vue?vue&type=template&id=1a64052f"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=1a64052f&lang=css"
script.render = render

export default script